import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=082b8274&scoped=true"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"
import style0 from "./pdf.vue?vue&type=style&index=0&id=082b8274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b8274",
  null
  
)

export default component.exports